import { ComponentType } from 'react';
import { useCurrentEvent } from '@hooks/events/use-current-event';

interface EventRouteWrapperProps {
  publishedComponent: ComponentType;
  draftComponent: ComponentType;
}

export const EventRouteWrapper = ({
  publishedComponent: PublishedComponent,
  draftComponent: DraftComponent,
}: EventRouteWrapperProps) => {
  const { event, isLoading } = useCurrentEvent();

  if (isLoading || !event) return null;

  return event.isPublished ? <PublishedComponent /> : <DraftComponent />;
};
